import { PaymentSortFilter } from "components/filters/Filters/SortFilter";
import BookkeepingFilter from "components/filters/Filters/BookkeepingFilter";
import CompanyFilter from "components/filters/Filters/CompanyFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import PaymentMethodFilter from "components/filters/Filters/PaymentMethodFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import React from "react";

const Filters = () => {
  return <>
    <KeywordFilter placeholder={RESX.GeneralLabels.Keyword} />
    <CompanyFilter title={RESX.Payment.ReceivedFrom} />
    <PaymentMethodFilter />
    <BookkeepingFilter />
    <PeriodFilter />
    <PaymentSortFilter />
  </>;
};

export default Filters;